import http from "../http/http-config";
import { Destination } from "../models/destination";
import { QuantityOfTravels } from "../models/quantityOfTravels";
import { TravelAssistanceQuotationResponse } from "../models/travelAssistanceQuotationResponse";

export default new class TravelAssistanceService {
    getDestination(): Promise<Destination[]> {
        return http.get<Destination[]>("TravelAssistance/GetDestination")
            .then(response => response.data);
    }
    getQuantityOfTravels(): Promise<QuantityOfTravels[]> {
        return http.get<QuantityOfTravels[]>("TravelAssistance/GetQuantityOfTravels")
            .then(response => response.data);
    }
    quotePlans(model: any): Promise<TravelAssistanceQuotationResponse> {
        return http.post<TravelAssistanceQuotationResponse>("TravelAssistance/QuotePlans", model)
            .then(response => response.data);
    }
}
